import { getData, postData, putData, deleteData } from "../apiClient";

// ─── Paginated list ───────────────────────────────────────────────────────────

export const getBlogsWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({ page: String(page), limit: String(limit), search });
        const result = await getData(`/blog/?${queryParams}`, {}, {}, signal);
        return { success: true, ...result };
    } catch (error) {
        console.error("Get Blogs pagination API error:", error);
        return { success: false, ...error };
    }
};

// ─── Single record ────────────────────────────────────────────────────────────

export const getBlogDataWithId = async (id) => {
    try {
        const result = await getData(`/blog/${id}`);
        return { data: { success: true, ...result } };
    } catch (error) {
        console.error("Get Blog by ID API error:", error);
        return { data: { success: false, error: error.message } };
    }
};

// ─── Create ───────────────────────────────────────────────────────────────────

export const createBlog = async ({ data }) => {
    try {
        const result = await postData(`/blog/create-blog`, data, { "Content-Type": "multipart/form-data" });
        return { data: { success: true, data: result } };
    } catch (error) {
        console.error("Create Blog API error:", error);
        return { data: { success: false, error: error.status === 400 ? error.data?.error : error.message, status: error.status } };
    }
};

// ─── Update ───────────────────────────────────────────────────────────────────

export const updateBlog = async ({ id, data }) => {
    try {
        const result = await putData(`/blog/update-blog/${id}`, data, { "Content-Type": "multipart/form-data" });
        return { data: { success: true, data: result } };
    } catch (error) {
        console.error("Update Blog API error:", error);
        return { data: { success: false, error: error.status === 400 ? error.data?.error : error.message, status: error.status } };
    }
};

// ─── Delete ───────────────────────────────────────────────────────────────────

export const deleteBlog = async ({ id }) => {
    try {
        const result = await deleteData(`/blog/delete-blog/${id}`);
        return { data: { success: true, data: result } };
    } catch (error) {
        console.error("Delete Blog API error:", error);
        return { data: { success: false, error: error.status === 400 ? error.error : error.message, status: error.status } };
    }
};
